import Reveal from "@/components/site/Reveal";
import { Icon } from "@/components/site/Icon";
import { WHY_CHOOSE } from "@/data/content";
import { FaCheck } from "react-icons/fa6";

const WhyChoose = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative overflow-hidden bg-green-primary py-24 text-white md:py-32"
    >
      <div className="pointer-events-none absolute -left-20 top-10 h-96 w-96 rounded-full bg-gold-soft/10 blur-[120px]" />
      <div className="pointer-events-none absolute -right-24 bottom-0 h-96 w-96 rounded-full bg-gold-light/10 blur-[120px]" />

      <div className="relative mx-auto max-w-[1300px] px-6 md:px-10">
        <Reveal className="mb-16 max-w-3xl">
          <p className="mb-4 flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.25em] text-gold-primary">
            <span className="h-px w-8 bg-gold-primary" /> Why Choose PLACE8
          </p>
          <h2 className="font-display text-4xl font-extralight leading-[1.05] tracking-tightest text-white md:text-6xl">
            The standards behind our <span className="italic text-gradient-gold">recruitment excellence.</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-white/85 md:text-lg font-normal">
            We combine deep industry insights, proactive talent mapping, and transparent execution
            to deliver hiring results that outperform expectations.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_CHOOSE.map((f, i) => (
            <Reveal
              key={f.title}
              delay={(i % 4) * 0.07}
              className="group rounded-3xl border border-gold-soft/30 bg-green-secondary/90 p-7 backdrop-blur-sm transition-all duration-500 hover:-translate-y-2 hover:border-gold-primary hover:bg-green-secondary flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className="grid h-12 w-12 place-items-center rounded-2xl bg-gold-primary text-xl text-white transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3 shadow-md">
                    <Icon name={f.icon} />
                  </span>
                  <span className="grid h-6 w-6 place-items-center rounded-full bg-gold-primary/20 text-gold-primary text-xs">
                    <FaCheck />
                  </span>
                </div>

                <h3 className="mt-6 text-lg font-bold text-white group-hover:text-gold-primary transition-colors">
                  {f.title}
                </h3>
                <p className="mt-3 text-xs leading-relaxed text-white/80">
                  {f.desc}
                </p>
              </div>

              <div className="mt-6 border-t border-gold-soft/20 pt-3">
                <span className="text-[10px] font-bold uppercase tracking-widest text-gold-primary flex items-center gap-1">
                  ✔ Verified Standard
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
